// Score pill: number bubble + band label. Uses .pill / .pill .n classes
// from global.css with the s/w colour modifiers from scoring.ts.

import { pillVariant, scoreLabel } from "../lib/scoring";

export function ScorePill({ score }: { score: number }) {
  const variant = pillVariant(score);
  const className = variant ? `pill ${variant}` : "pill";
  return (
    <span className={className}>
      <span className="n">{Math.round(score)}</span>
      {scoreLabel(score)}
    </span>
  );
}
